// Hook to handle performing some event (like closing a menu) when clicking outside of it
// Taken from the Mantine hooks library
//
// https://github.com/mantinedev/mantine/blob/master/src/mantine-hooks/src/use-click-outside/use-click-outside.ts
// eslint-disable-next-line import/no-extraneous-dependencies
import { useEffect, useRef } from 'react';
var DEFAULT_EVENTS = ['mousedown', 'touchstart'];
export function useClickOutside(handler, events, nodes) {
    var ref = useRef();
    useEffect(function () {
        var listener = function (event) {
            if (Array.isArray(nodes)) {
                var shouldTrigger = nodes.every(function (node) { return !!node && !node.contains(event.target); });
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                shouldTrigger && handler();
            }
            else if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        };
        (events || DEFAULT_EVENTS).forEach(function (fn) { return document.addEventListener(fn, listener); });
        return function () {
            (events || DEFAULT_EVENTS).forEach(function (fn) { return document.removeEventListener(fn, listener); });
        };
    }, [ref, handler, nodes]);
    return ref;
}
